const actionTypes = {
  SET_MODAL_CONFIRM_API_KEY_ACTIVED: 'setModalConfirmApiKeyActived',
  SET_API_KEY_DATAS: 'setApiKeyDatas',
}

export default actionTypes
